import axiosNextGen from '../../../config/axios-nextgen';

/**
 * ORU API Log Service
 * Handles ORU API log retrieval and filtering
 */

/**
 * Get paginated ORU API logs
 * @param {Object} params - Optional query parameters
 * @param {number} [params.page=1]
 * @param {number} [params.pageSize=50]
 * @param {string} [params.search]
 * @param {number} [params.statusCode]
 * @param {string} [params.reportState]
 * @param {string} [params.dateFrom]
 * @param {string} [params.dateTo]
 * @param {boolean} [params.hasErrors]
 * @param {string} [params.sortBy='timestamp']
 * @param {string} [params.sortDirection='desc']
 * @returns {Promise<{Data: Array, Pagination: Object, Filters: Object}>}
 */
export async function getLogs(params = {}) {
    const response = await axiosNextGen.get('/api/oruapilog/logs', { params });
    return response.data;
}

/**
 * Get a single ORU API log by ID
 * @param {number|string} logId
 * @returns {Promise<Object>}
 */
export async function getLogDetail(logId) {
    const response = await axiosNextGen.get(`/api/oruapilog/logs/${logId}`);
    return response.data;
}
